module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: this['class']
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ddcc2c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/grid/Column.vue
// module id = 777
// module chunks = 0